export enum IncidentFactor {
  CRIME_SCENE = "Crime",
  HAZMAT = "Hazmat",
  FIRE = "Fire",
  FATALITY = "Fatality",
  ROLLOVER = "Rollover",
  COMMERCIAL_VEHICLE = "Comm. Veh.",
}
